import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LicenseManager } from 'ag-grid-enterprise';
import { AllCommunityModule, ModuleRegistry } from 'ag-charts-community';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Capture the PWA `beforeinstallprompt` event as early as possible.
// Chromium browsers fire this very soon after page load — often BEFORE the
// Angular component that listens for it has mounted. We stash the event on
// `window` so the install-prompt component can pick it up when it initializes.
(window as unknown as { __liqDeferredInstallPrompt?: Event }).__liqDeferredInstallPrompt = undefined;
window.addEventListener('beforeinstallprompt', (event: Event) => {
    event.preventDefault();
    (window as unknown as { __liqDeferredInstallPrompt?: Event }).__liqDeferredInstallPrompt = event;
    // Re-dispatch as a custom event so an already-mounted component is notified too.
    window.dispatchEvent(new CustomEvent('liq:beforeinstallprompt', { detail: event }));
});

// Register AG Charts modules (required since v13)
ModuleRegistry.registerModules(AllCommunityModule);

// eslint-disable-next-line max-len
LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-096247}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{LS&s_and_American_Library_Association}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{LibraryIQ}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{LibraryIQ}_need_to_be_licensed___{LibraryIQ}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{22_February_2027}____[v3]_[01]_MTgwMzI1NDQwMDAwMA==1f7df00c9f8c6106dccedbc17c7dcb21'
);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

// Register the PWA service worker. Required for Chrome/Edge/Brave/Opera/
// Firefox-Android to consider the site installable. We register from
// main.ts (not the app module) so it runs as early as possible and never
// blocks Angular bootstrap. Skipped automatically in dev (file is served
// from disk in prod builds via angular.json `assets`).
if ('serviceWorker' in navigator) {
    // Defer registration until after `load` so it never competes with
    // bootstrap for network/CPU.
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err) => {
            console.warn('[PWA] Service worker registration failed:', err);
        });
    });
}
